export enum COUNTRIES {
  ARG = 'ARG',
  BR = 'BR',
  MX = 'MX',
  CO = 'CO',
  PE = 'PE'
}
